import Tolls from '../../../services/toll';

export default{
  props: ['orderData'],
  data() {
    return {
      dataTransfer:undefined,
      loading: undefined,
      summaryVP: {}
    }
  },
  computed: {
  },
  methods: {
    print() {
      var prtContent = document.getElementById("comprovante");
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    closeModal() {
      this.$emit('close', false);
      this.dataTransfer = {};
    }
  },
  mounted(){
    
      $('[data-toggle="tooltip"]').tooltip();

      this.loading = Tolls.getTransfer(this.orderData.orderId).then(resp => {
        this.dataTransfer = resp.transfer;
        
      }).catch(err => {
        
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/shipper/modal-receipt-transfer.js